import React, { useState } from 'react'
import { IconButton } from '@material-ui/core'
import TuneRoundedIcon from '@material-ui/icons/TuneRounded'
import useTranslation from 'Hooks/useTranslation'
import { SlideMenu, SlideMenuSection } from 'Components/SlideMenu/SlideMenu'
import './MobileActionsMenu.styles.scss'

// icon button that replaces the page action buttons on mobile and opens them in a left slide menu
// action: { id, icon, label, hint, group, onClick } or { ..., renderContent: close => node } for an expandable section,
// group sets the accent color the same way as on the quick add tiles
const MobileActionsMenu = ({ actions }) => {
    const translation = useTranslation()
    const [open, setOpen] = useState(false)
    const [expandedId, setExpandedId] = useState(null)

    const close = () => {
        setOpen(false)
        setExpandedId(null)
    }

    const handleActionClick = action => {
        if (action.renderContent) {
            setExpandedId(expandedId === action.id ? null : action.id)
            return
        }
        close()
        action.onClick()
    }

    if (!actions.length) return null

    return (
        <>
            <IconButton
                className="mobileActionsMenuBtn"
                id="mobileActionsMenuBtn"
                aria-label={translation.dashboardActionsLabel}
                onClick={() => setOpen(true)}
            >
                <TuneRoundedIcon />
            </IconButton>
            <SlideMenu open={open} onClose={close} title={translation.dashboardActionsLabel}>
                {actions.map(action => (
                    <SlideMenuSection
                        key={action.id}
                        id={`mobileActionsMenuBtn-${action.id}`}
                        icon={action.icon}
                        label={action.label}
                        hint={action.hint}
                        group={action.group}
                        expanded={expandedId === action.id}
                        onClick={() => handleActionClick(action)}
                    >
                        {action.renderContent && action.renderContent(close)}
                    </SlideMenuSection>
                ))}
            </SlideMenu>
        </>
    )
}

export default MobileActionsMenu
